import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/cn';

export function StatCard({
  icon,
  label,
  value,
  sub,
  accent,
  warn,
}: {
  icon: ReactNode;
  label: string;
  value: string;
  sub?: string;
  accent?: boolean;
  warn?: boolean;
}) {
  return (
    <Card className={cn(accent && 'border-primary/30')}>
      <CardContent className="flex items-center gap-3 p-4">
        <div
          className={cn(
            'grid h-10 w-10 shrink-0 place-items-center rounded-md bg-primary/10 text-primary',
            warn && 'bg-destructive/10 text-destructive',
            accent && 'bg-primary/15',
          )}
        >
          {icon}
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="text-xl font-semibold leading-tight">{value}</p>
          {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
